module.exports = __webpack_public_path__ + "img/bg_main_menu_renewal.4b01537.png";